// src/data/Updates.js
export const updates = [
  {
    date: "2026-06-15",
    type: "new",
    description: "Seven Shadow Summit",
    chapterSlug: "sevenshadowsummit"
  },
  {
    date: "2026-06-14",
    type: "new",
    description: "Forest of Death: Day 2",
    chapterSlug: "theforestofdeath/day2"
  },
  {
    date: "2026-06-01",
    type: "new",
    description: "Compendium: Hand Seals",
    compendiumSlug: "handseals"
  },
  {
    date: "2026-01-07",
    type: "new",
    description: "Sasuke vs Dosu",
    chapterSlug: "finals/sasukevsdosu"
  },
  {
    date: "2026-01-03",
    type: "new",
    description: "After Hiruzen",
    chapterSlug: "shadowless/afterhiruzen"
  },
  {
    date: "2026-01-03",
    type: "new",
    description: "After Rasa",
    chapterSlug: "shadowless/afterrasa"
  },
  {
    date: "2025-12-29",
    type: "article",
    description: "Why Naruto: Saihen?",
    articleSlug: "whynarutosaihen"
  },
    {
    date: "2025-12-28",
    type: "bugfix",
    description: "Fixed broken urls"
  },
  {
    date: "2025-12-21",
    type: "new",
    description: "What Won't Die",
    chapterSlug: "whatwontdie"
  },
  {
    date: "2025-12-15",
    type: "new",
    description: "The Forest of Death: Day 1",
    chapterSlug: "theforestofdeath/day1"
  }
];
